import { useAppSelector } from "hooks/store";
import React, { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

const HorizontalMenu = () => {
  const sideBarMenu = useAppSelector(({ main }) => main.sideBarMenu);
  const displayOption = useAppSelector(
    ({ main }) => main.settings.DeptDisplayOption
  );
  const [searchParams, setSearchParams] = useSearchParams();
  const product = useMemo(
    () => +(searchParams.get("product") || 0),
    [searchParams]
  );

  return (
    <div className="flex space-x-4 p-3 bg-white border-b border-primary overflow-x-auto">
      {sideBarMenu.map(({ id, categoryDescription, imageUrl }) => (
        <div
          key={id}
          className={`capitalize transition-all duration-300 py-1.5 px-3 rounded-lg cursor-pointer font-medium flex gap-3 items-center ${
            product === id
              ? "bg-primary text-themeSelColor"
              : "hover:bg-primary/20 text-deptColor"
          } flex-shrink-0 `}
          onClick={() => {
            let search = searchParams;
            search.set("product", id.toString());
            setSearchParams(search);
          }}
        >
          {["Image", "Both"].includes(displayOption) && !!imageUrl && (
            <img src={imageUrl} alt="logo" className="w-8 h-8 rounded-full" />
          )}

          {["Text", "Both"].includes(displayOption) && (
            <span className="block overflow-hidden overflow-ellipsis whitespace-normal line-clamp-2">
              {categoryDescription.toLowerCase()}
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

export default HorizontalMenu;
